import {
  AppBar,
  Grid,
  Toolbar,
  useTheme,
  useMediaQuery,
} from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { Logo } from '../../Logos'
import { loginUser } from '../../redux/Actions/Login'
import { connect } from 'react-redux'
import { useEffect } from 'react'
import Config from '../../config/Config'
import { useStyles } from './Styles'
import LoadingComponent from '../../components/LoadingComponent/LoadingComponent'
import { ServiceResponse } from './Messages'
import { routes, WEB_APP_NAME } from '../../util/Constants'

function Login(props: any) {
  const { loginUser, user, isLoading, errorMessage, error } = props
  const { DEFAULT, DASHBOARD } = routes
  const theme = useTheme()
  const active = useMediaQuery(theme.breakpoints.down(500))
  const moresmall = useMediaQuery(theme.breakpoints.down(320))
  const classes = useStyles()
  let history = useHistory()
  const { GOOGLE_CLIENT_ID } = Config
  const handleCredentialResponse = (response: any) => {
    if (response?.credential) {
      localStorage.setItem('_Gresponse', JSON.stringify(response))
      const idToken = response?.credential
      loginUser(idToken)
    }
  }
  useEffect(() => {
    initiateGoogleLogin()
  }, [])

  const initiateGoogleLogin = () => {
    const windowObj: any = window
    const googleClientId: any = GOOGLE_CLIENT_ID
    windowObj.google.accounts.id.initialize({
      client_id: googleClientId,
      callback: handleCredentialResponse,
      use_fedcm_for_prompt: true,
    })
    windowObj.google.accounts.id.renderButton(
      document.getElementById('buttonDiv'),
      { theme: 'filled_black', size: 'wide', shape: 'pill' } // customization attributes
    )
    windowObj.google.accounts.id.prompt() // also display the One Tap dialog
  }

  useEffect(() => {
    if (
      localStorage.getItem('_Gresponse') &&
      localStorage.getItem('_GresponseV2')
    ) {
      history.push(`${DEFAULT}${DASHBOARD}`)
    }
  }, [DASHBOARD, DEFAULT, history])

  useEffect(() => {
    if (user) {
      if (!isLoading && errorMessage.toLowerCase() !== 'usernotadded')
        history.push(`${DEFAULT}${DASHBOARD}`)
      else history.push('/login')
    }
  }, [user, history, errorMessage, isLoading, DEFAULT, DASHBOARD])
  useEffect(() => {
    if (error) {
      history.push('/login')
      initiateGoogleLogin()
    }
  }, [error, history])

  return (
      <div style={{ flexGrow: 1 }}>
        <AppBar
          style={{
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Toolbar
            style={{
              alignItems: 'center',
              justifyContent: 'center',
              height: !active ? '40vh' : '20vh',
            }}
          >
            <Grid container className={classes.gridContainer}>
              <Grid item className={classes.logo} xs={4} xl={4} md={4} lg={4}>
                <Logo height={500} />
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>
        <div
          className={classes.height}
          style={{ height: !active ? '30vh' : '10vh' }}
        />
        <div
          style={{
            display: 'flex',
            flexGrow: 1,
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            marginTop: 10,
            height: !moresmall ? '50vh' : '40vh',
          }}
        >
          <div
            className={!moresmall ? 'display6' : 'display7'}
            style={{ color: '#004e37' }}
          >
            {WEB_APP_NAME}
          </div>
          <br />
          <div id="buttonDiv"></div>
        </div>
        <div
          className={classes.error}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            marginTop: 10,
          }}
        >
          {errorMessage.toLowerCase() === 'usernotadded'
            ? ServiceResponse.getMessage('app', 'usernotadded')
            : errorMessage}
        </div>
        <LoadingComponent showLoader={isLoading} />
      </div>
  )
}

const mapStateToProps = (state: any) => {
  return {
    user: state.loginReducer.user,
    error: state.loginReducer.error,
    errorMessage: state.loginReducer.errorMessage,
    isLoading: state.loginReducer.isLoading,
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    loginUser: (idToken: any) => dispatch(loginUser(idToken)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)
